export const isInternalOrg = (email: string) => {
  return email.endsWith('@seapoint.co');
};
